module.exports = __webpack_public_path__ + "static/media/compressed-about-us.4b6933f1.jpg";